import { $nin as __nin, createQueryOperator } from "../../_predicates";
const $nin = createQueryOperator(__nin);
export {
  $nin
};
